<template>
  <div class="view-all-courses">
    <section class="py-5">
      <div class="container pt-5">
        <h1 class="mb-5">Cursos em destaque</h1>

        <action-dispatcher
          action="courses/getFeatured"
          :parameters="{ type: 'olavo' }"
        >
          <carousel
            :per-page="1"
            :navigation-enabled="true"
            navigation-next-label="<i class='icon-chevron-right'></i>"
            navigation-prev-label="<i class='icon-chevron-left'></i>"
          >
            <slide v-for="(course, index) in featured" :key="index">
              <about :course="course" />
            </slide>
          </carousel>
        </action-dispatcher>
      </div>
    </section>

    <section class="py-5">
      <div class="container pb-5">
        <h2 class="mb-4">Todos os cursos</h2>

        <action-dispatcher action="courses/getCategories">
          <simple-nav
            v-model="extraParameters.category"
            :options="categoryOptions"
            @input="selectCategory"
          />
        </action-dispatcher>

        <action-dispatcher
          action="courses/getAll"
          ref="actionDispatcher"
          :parameters="{
            ...parameters,
            type: 'olavo'
          }"
        >
          <div
            v-if="!courses || courses.length === 0"
            class="small text-center text-secondary p-3"
          >
            <em>Nenhum curso</em>
          </div>

          <div class="row">
            <div
              v-for="(course, index) in courses"
              class="col-lg-3 col-md-6 my-2 d-flex flex-column"
              :key="index"
            >
              <course-card class="flex-fill" :course="course" />
            </div>
          </div>
        </action-dispatcher>

        <!-- <pagination
          class="pt-5"
          :count="count"
          :page="page"
          :limit="parameters.limit"
          @paginate="paginate"
        /> -->
      </div>
    </section>
  </div>
</template>

<script>
import Pagination from "@/mixins/Pagination";
import CourseCard from "@/components/courses/CourseCard";
import About from "@/components/courses/About";
import { Carousel, Slide } from "vue-carousel";
import { mapState } from "vuex";

export default {
  components: { CourseCard, Carousel, Slide, About },
  mixins: [Pagination],
  data() {
    return {
      perPage: 1000,
      extraParameters: { category: "" }
    };
  },
  computed: {
    ...mapState("courses", ["courses", "featured", "count", "categories"]),
    categoryOptions() {
      return [{ id: "", name: "Todas" }, ...this.categories];
    }
  },
  methods: {
    reload() {
      this.$refs.actionDispatcher.dispatch();
    },
    selectCategory() {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...this.extraParameters
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-all-courses {
  h1 {
    margin-bottom: 0;
  }
}
</style>
